import type { CctpDirection, CctpTransferTags } from "@/utils/cctp/telemetry";

// Type-only: the card module pulls in icons, which these pure helpers' tests have no reason to load.
import type { TransferProgressData } from "./transfer-progress-card";

type CctpCard = Extract<TransferProgressData, { type: "cctp-deposit" | "cctp-withdraw" }>;

/** The telemetry tags for a CCTP card. Only deposits can be Fast, so only they carry speed. */
export function transferTags(transfer: CctpCard): CctpTransferTags {
  if (transfer.type === "cctp-withdraw") {
    return { cctpVersion: transfer.cctpVersion, direction: "withdraw" };
  }
  return {
    cctpVersion: transfer.cctpVersion,
    direction: "deposit",
    ...(transfer.speed && { speed: transfer.speed }),
    ...(transfer.delayReason && { delayReason: transfer.delayReason }),
  };
}

/** A resume lookup's direction: the withdraw pane looks up the burn on Aptos. */
export function resumeDirection(lookupChain: string): CctpDirection {
  return lookupChain === "Aptos" ? "withdraw" : "deposit";
}
